import { realTimeApiInstance } from '../api';

export interface LatestAssetTrendDataPoint {
  name: string;
  value: string | null;
  date: string;
  uom: string;
  short_UOM: string;
  paramTypeId: string;
  address: string | null;
  cov: string | null;
  cumulativeCOV: string | null;
}

export const fetchLatestAssetTrendDataInitialState = async (
  assetId: string,
  ParamStdTypes: (string | number)[] = [],
  signal?: AbortSignal,
) => {
  try {
    const response = await realTimeApiInstance.get('RealTimeData/GetLatestAssetTrendsGraphData', {
      params: {
        AssetId: assetId,
        ParamStdTypes: ParamStdTypes.join(','),
      },
      signal,
    });

    return response;
  } catch (error) {
    console.error('Error fetching latest asset trend data:', error);
    return undefined;
  }
};
